"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = _interopRequireDefault(require("./svg"));

var _button = _interopRequireDefault(require("./button"));

var _markdown = _interopRequireDefault(require("./markdown"));

require("./notification.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-line
var LEVEL_TO_ICON = {
  success: 'check-circle',
  warning: 'exclamation-circle',
  error: 'times-circle',
  info: 'info-circle'
};

var Notification = function Notification(props) {
  var actionButton;

  if (props.onCallToAction && props.callToActionText) {
    actionButton = /*#__PURE__*/_react["default"].createElement(_button["default"], {
      size: "small",
      type: "text",
      className: "action",
      onClick: props.onCallToAction
    }, props.callToActionText);
  }

  var timerBar;

  if (props.timeRemaining) {
    var timePercent = props.timeRemaining / (props.timeTotal || props.timeRemaining) * 100;
    timerBar = /*#__PURE__*/_react["default"].createElement("div", {
      className: "timer-bar",
      style: {
        width: "".concat(timePercent, "%"),
        'animation-duration': "".concat(props.timeRemaining, "ms")
      }
    });
  }

  var header;
  var iconId = props.iconId ? props.iconId : LEVEL_TO_ICON[props.level];

  var svgIcon = /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: iconId,
    className: "level"
  });

  if (props.hideHeader !== true) {
    var closeButton = props.onDismiss ? /*#__PURE__*/_react["default"].createElement(_svg["default"], {
      id: "close",
      className: "closeButton",
      onClick: props.onDismiss
    }) : null;
    header = /*#__PURE__*/_react["default"].createElement("div", {
      className: "header h4"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "h4"
    }, props.title), closeButton);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Notification ".concat(props.level)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, svgIcon, /*#__PURE__*/_react["default"].createElement("div", {
    className: "body"
  }, header, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: props.text
  }), actionButton), timerBar));
};

Notification.propTypes = {
  hideHeader: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  iconId: _propTypes["default"].string,
  level: _propTypes["default"].oneOf(['success', 'warning', 'error', 'info']),
  timeTotal: _propTypes["default"].number,
  timeRemaining: _propTypes["default"].number,
  onCallToAction: _propTypes["default"].func,
  callToActionText: _propTypes["default"].string,
  onDismiss: _propTypes["default"].func // Add ability to dismiss with X

};
Notification.defaultProps = {
  hideHeader: false,
  text: null,
  iconId: null,
  title: '',
  onCallToAction: null,
  callToActionText: null,
  level: 'info',
  onDismiss: null,
  timeTotal: null,
  timeRemaining: null
};
var _default = Notification;
exports["default"] = _default;